document.addEventListener('DOMContentLoaded', ()=>{
  const header = document.querySelector('.mp-header');
  const header_group = header.closest('.shopify-section');

  const collection_filter = document.querySelector('.collection-toolbar');
  if (collection_filter != null) {
    collection_filter.style.top = `${header.offsetHeight}px`;
  }
  document.body.style.paddingTop = `${header.offsetHeight}px`;
  
  const swiper = new Swiper('.fvSwiper', {
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  });

  const drawerButton = document.querySelector('.mp-header__drawer-toggle');
  const drawer = document.querySelector('.mp-header__drawer');
  function closeDrawer() {
    drawerButton.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    header_group.classList.remove('drawer-open');
  }
  const closer = document.querySelectorAll('.js-drawer-close');
  closer.forEach(item=>{
    item.addEventListener('click', closeDrawer);
  });

  drawerButton.addEventListener('click', ()=>{
    const isExpanded = drawerButton.getAttribute('aria-expanded') === 'true';
    header_group.classList.toggle('drawer-open');
    drawerButton.setAttribute('aria-expanded', !isExpanded);
    drawer.setAttribute('aria-hidden', isExpanded);
  });

});